import React from 'react'
const Icon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12239_32030)">
      <path
        d="M20.9853 3.51473C18.7188 1.24823 15.7053 0 12.5 0C9.29469 0 6.28119 1.24823 4.01473 3.51473C1.74819 5.78119 0.5 8.79469 0.5 12C0.5 15.2053 1.74819 18.2188 4.01473 20.4853C6.28119 22.7518 9.29469 24 12.5 24C15.7053 24 18.7188 22.7518 20.9853 20.4853C23.2518 18.2188 24.5 15.2053 24.5 12C24.5 8.79469 23.2518 5.78119 20.9853 3.51473ZM12.5 22.5714C6.67091 22.5714 1.92856 17.8291 1.92856 12C1.92856 6.17091 6.67091 1.42856 12.5 1.42856C18.3291 1.42856 23.0714 6.17091 23.0714 12C23.0714 17.8291 18.3291 22.5714 12.5 22.5714Z"
        fill="currentColor"
      />
      <path
        d="M9.90422 8.8309C8.73454 7.66114 6.83128 7.66123 5.66161 8.8309C5.38265 9.10981 5.38265 9.56211 5.66161 9.84106C5.94061 10.12 6.3929 10.12 6.67181 9.84106C7.28456 9.22836 8.2815 9.2284 8.89415 9.84106C9.03365 9.98056 9.21642 10.0503 9.39919 10.0503C9.58195 10.0503 9.76481 9.98056 9.90422 9.84106C10.1832 9.56211 10.1832 9.10986 9.90422 8.8309Z"
        fill="currentColor"
      />
      <path
        d="M19.3383 8.8309C18.1686 7.66123 16.2654 7.66114 15.0957 8.8309C14.8167 9.10981 14.8167 9.56211 15.0957 9.84106C15.3747 10.12 15.827 10.12 16.1059 9.84106C16.7185 9.22836 17.7155 9.22831 18.3282 9.84106C18.4677 9.98056 18.6505 10.0503 18.8333 10.0503C19.016 10.0503 19.1989 9.98056 19.3383 9.84106C19.6173 9.56211 19.6173 9.10986 19.3383 8.8309Z"
        fill="currentColor"
      />
      <path
        d="M18.8333 12.5239H6.16667C5.77217 12.5239 5.45239 12.8438 5.45239 13.2382C5.45239 17.1242 8.61397 20.2858 12.5 20.2858C16.386 20.2858 19.5476 17.1242 19.5476 13.2382C19.5476 12.8437 19.2278 12.5239 18.8333 12.5239ZM12.5 18.8573C9.64353 18.8573 7.27803 16.7149 6.92614 13.9525H18.0739C17.722 16.7149 15.3565 18.8573 12.5 18.8573Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_12239_32030">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
export default Icon
